import { render } from "./MdSnackbarWrapper.vue?vue&type=template&id=3aaecb92&scoped=true&ts=true"
import script from "./MdSnackbarWrapper.vue?vue&type=script&lang=ts"
export * from "./MdSnackbarWrapper.vue?vue&type=script&lang=ts"

import "./MdSnackbarWrapper.vue?vue&type=style&index=0&id=3aaecb92&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aaecb92"]])

export default __exports__